import Script from 'next/script';

const TrackingTagScript = () => {
  return process.env.NEXT_PUBLIC_ENGAGE_BOT_UQID && process.env.NEXT_PUBLIC_ENGAGE_BOT_GID ? (
    <Script id="tracking-tag" strategy="afterInteractive" type="text/javascript">
      {`
        (function () {
            var uqid = '${process.env.NEXT_PUBLIC_ENGAGE_BOT_UQID}'
            var gid = '${process.env.NEXT_PUBLIC_ENGAGE_BOT_GID}'
            var uid = ''
            var uid2 = ''
            var af = ''
            var pid = ''
            var amount = '';
            var a = document.createElement('script');
            a.src='//ac.eb.react.tokyo/ac/action_js.php';
            a.id='afadaction-' + Date.now();
            a.addEventListener('load', function () {
              (new fpcAction(a.id)).groupAction(gid, af, [uid, uid2], pid, amount, uqid)
            });
            document.head.appendChild(a);
          })();
      `}
    </Script>
  ) : null;
};

export default TrackingTagScript;
